<template>
  <div class="data-sources-container">
    <div class="page-header">
      <h1 class="text-2xl font-semibold text-gray-900">Data sources</h1>
    </div>

    <div class="content-section">
      <h2 class="text-lg font-medium text-gray-800 mb-4">Connected sources</h2>
      
      <div class="source-cards">
        <div class="source-card connected" @click="navigateToConnector('Bureau of Meteorology')" style="cursor: pointer;">
          <div class="source-icon">
            <img src="https://www.bom.gov.au/sites/default/files/styles/778/public/2020-11/BOM-Weather-app-icon-square.png.webp" alt="Google Drive" class="h-10 w-10">
          </div>
          <div class="source-info">
            <div class="source-name">Bureau of Meteorology</div>
            <div class="source-status success">
              <span class="status-dot-connected"></span>
              <span class="status-text">CONNECTED</span>
              <button class="text-green-600 text-xs ml-2">VIEW DETAILS</button>
            </div>
          </div>
          <div class="source-action">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div class="content-section mt-8">
      <h2 class="text-lg font-medium text-gray-800 mb-4">Available sources</h2>
      
      <div class="source-cards grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <!-- AgData -->
        <div class="source-card" @click="navigateToConnector('AgData')" style="cursor: pointer;">
          <div class="source-icon">
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSFe6CIeHyiBKUw_8dWpCTjTh4NlhzC0bz58A&s" alt="AgData" class="h-15 w-15">
          </div>
          <div class="source-info">
            <div class="source-name">AgData</div>
            <div class="source-connect">CONNECT THIS SOURCE</div>
          </div>
          <div class="source-action">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>

        <!-- AgriChain -->
        <div class="source-card" @click="navigateToConnector('AgriChain')" style="cursor: pointer;">
          <div class="source-icon">
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRbmXpDhr1e3Us8J6cqTwaBn-98Z3Vct70Pww&s" alt="AgriChain" class="h-10 w-10">
          </div>
          <div class="source-info">
            <div class="source-name">AgriChain</div>
            <div class="source-connect">CONNECT THIS SOURCE</div>
          </div>
          <div class="source-action">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>

        <!-- AgriDigital -->
        <div class="source-card" @click="navigateToConnector('AgriDigital')" style="cursor: pointer;">
          <div class="source-icon">
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR65M2J5KfHBCqpYbdb0cBmXiICYndrJrpsaQ&s" alt="AgriDigital" class="h-10 w-10">
          </div>
          <div class="source-info">
            <div class="source-name">AgriDigital</div>
            <div class="source-connect">CONNECT THIS SOURCE</div>
          </div>
          <div class="source-action">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>

        <!-- AgriWebb -->
        <div class="source-card" @click="navigateToConnector('AgriWebb')" style="cursor: pointer;">
          <div class="source-icon">
            <img src="https://avatars.githubusercontent.com/u/13633868?s=200&v=4" alt="AgriWebb" class="h-10 w-10">
          </div>
          <div class="source-info">
            <div class="source-name">AgriWebb</div>
            <div class="source-connect">CONNECT THIS SOURCE</div>
          </div>
          <div class="source-action">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>

        <!-- Agronomeye -->
        <div class="source-card" @click="navigateToConnector('Agronomeye')" style="cursor: pointer;">
          <div class="source-icon">
            <img src="https://i.tracxn.com/logo/company/agronomeye.com.au_Logo_01455d31-c57d-403c-99e7-57abb1c17e6d.jpg?format=webp&height=120&width=120" alt="Agronomeye" class="h-10 w-10">
          </div>
          <div class="source-info">
            <div class="source-name">Agronomeye</div>
            <div class="source-connect">CONNECT THIS SOURCE</div>
          </div>
          <div class="source-action">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>

        <!-- Agworld -->
        <div class="source-card" @click="navigateToConnector('Agworld')" style="cursor: pointer;">
          <div class="source-icon">
            <img src="https://play-lh.googleusercontent.com/TCMY0m7BESynZnE_XqRtH2kDUwjazlGegLksM-g8ebuDZjN8G3G8bEn7RCKVLiGtQCA" alt="Agworld" class="h-10 w-10">
          </div>
          <div class="source-info">
            <div class="source-name">Agworld</div>
            <div class="source-connect">CONNECT THIS SOURCE</div>
          </div>
          <div class="source-action">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>

        <!-- File CSV -->
        <div class="source-card" @click="navigateToConnector('File csv json excel feather parquet')" style="cursor: pointer;">
          <div class="source-icon">
            <img src="https://connectors.airbyte.com/files/metadata/airbyte/source-file/latest/icon.svg" alt="File" class="h-10 w-10">
          </div>
          <div class="source-info">
            <div class="source-name">File csv json excel feather parquet</div>
            <div class="source-connect">CONNECT THIS SOURCE</div>
          </div>
          <div class="source-action">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>

        <!-- Gmail -->
        <div class="source-card" @click="navigateToConnector('Gmail')" style="cursor: pointer;">
          <div class="source-icon">
            <img src="https://dev.junify.projuno.com/images/icons/sources/gmail.svg" alt="Gmail" class="h-10 w-10">
          </div>
          <div class="source-info">
            <div class="source-name">Gmail</div>
            <div class="source-connect">CONNECT THIS SOURCE</div>
          </div>
          <div class="source-action">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>

        <!-- Google Calendar -->
        <div class="source-card" @click="navigateToConnector('Google calendar')" style="cursor: pointer;">
          <div class="source-icon">
            <img src="https://dev.junify.projuno.com/images/icons/sources/google-calendar.svg" alt="Google Calendar" class="h-10 w-10">
          </div>
          <div class="source-info">
            <div class="source-name">Google calendar</div>
            <div class="source-connect">CONNECT THIS SOURCE</div>
          </div>
          <div class="source-action">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>

        <!-- Google Drive -->
        <div class="source-card" @click="navigateToConnector('Google drive')" style="cursor: pointer;">
          <div class="source-icon">
            <img src="https://connectors.airbyte.com/files/metadata/airbyte/source-google-drive/latest/icon.svg" alt="Google Drive" class="h-10 w-10">
          </div>
          <div class="source-info">
            <div class="source-name">Google drive</div>
            <div class="source-connect">CONNECT THIS SOURCE</div>
          </div>
          <div class="source-action">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>

        <!-- Google Sheets -->
        <div class="source-card" @click="navigateToConnector('Google sheets')" style="cursor: pointer;">
          <div class="source-icon">
            <img src="https://connectors.airbyte.com/files/metadata/airbyte/source-google-sheets/latest/icon.svg" alt="Google Sheets" class="h-10 w-10">
          </div>
          <div class="source-info">
            <div class="source-name">Google sheets</div>
            <div class="source-connect">CONNECT THIS SOURCE</div>
          </div>
          <div class="source-action">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>

        <!-- Microsoft Excel -->
        <div class="source-card" @click="navigateToConnector('Microsoft excel')" style="cursor: pointer;">
          <div class="source-icon">
            <img src="https://dev.junify.projuno.com/images/icons/sources/microsoft-excel.svg" alt="Microsoft Excel" class="h-10 w-10">
          </div>
          <div class="source-info">
            <div class="source-name">Microsoft excel</div>
            <div class="source-connect">CONNECT THIS SOURCE</div>
          </div>
          <div class="source-action">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>

        <!-- Microsoft OneDrive -->
        <div class="source-card" @click="navigateToConnector('Microsoft onedrive')" style="cursor: pointer;">
          <div class="source-icon">
            <img src="https://connectors.airbyte.com/files/metadata/airbyte/source-microsoft-onedrive/latest/icon.svg" alt="Microsoft OneDrive" class="h-10 w-10">
          </div>
          <div class="source-info">
            <div class="source-name">Microsoft onedrive</div>
            <div class="source-connect">CONNECT THIS SOURCE</div>
          </div>
          <div class="source-action">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>

        <!-- Microsoft Teams -->
        <div class="source-card" @click="navigateToConnector('Microsoft teams')" style="cursor: pointer;">
          <div class="source-icon">
            <img src="https://connectors.airbyte.com/files/metadata/airbyte/source-microsoft-teams/latest/icon.svg" alt="Microsoft Teams" class="h-10 w-10">
          </div>
          <div class="source-info">
            <div class="source-name">Microsoft teams</div>
            <div class="source-connect">CONNECT THIS SOURCE</div>
          </div>
          <div class="source-action">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>

        <!-- MySQL -->
        <div class="source-card" @click="navigateToConnector('Mysql')" style="cursor: pointer;">
          <div class="source-icon">
            <img src="https://connectors.airbyte.com/files/metadata/airbyte/source-mysql/latest/icon.svg" alt="MySQL" class="h-10 w-10">
          </div>
          <div class="source-info">
            <div class="source-name">Mysql</div>
            <div class="source-connect">CONNECT THIS SOURCE</div>
          </div>
          <div class="source-action">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>

        <!-- Outlook -->
        <div class="source-card" @click="navigateToConnector('Outlook')" style="cursor: pointer;">
          <div class="source-icon">
            <img src="https://connectors.airbyte.com/files/metadata/airbyte/source-outlook/latest/icon.svg" alt="Outlook" class="h-10 w-10">
          </div>
          <div class="source-info">
            <div class="source-name">Outlook</div>
            <div class="source-connect">CONNECT THIS SOURCE</div>
          </div>
          <div class="source-action">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>

        <!-- Quickbooks -->
        <div class="source-card" @click="navigateToConnector('Quickbooks')" style="cursor: pointer;">
          <div class="source-icon">
            <img src="https://connectors.airbyte.com/files/metadata/airbyte/source-quickbooks/latest/icon.svg" alt="Quickbooks" class="h-10 w-10">
          </div>
          <div class="source-info">
            <div class="source-name">Quickbooks</div>
            <div class="source-connect">CONNECT THIS SOURCE</div>
          </div>
          <div class="source-action">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>

        <!-- Xero -->
        <div class="source-card" @click="navigateToConnector('Xero')" style="cursor: pointer;">
          <div class="source-icon">
            <img src="https://connectors.airbyte.com/files/metadata/airbyte/source-xero/latest/icon.svg" alt="Xero" class="h-10 w-10">
          </div>
          <div class="source-info">
            <div class="source-name">Xero</div>
            <div class="source-connect">CONNECT THIS SOURCE</div>
          </div>
          <div class="source-action">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataSourcesPage',
  data() {
    return {
      sourceIds: {
        'AgData': 'agdata',
        'AgriChain': 'agrichain',
        'AgriDigital': 'agridigital',
        'AgriWebb': 'agriwebb',
        'Agronomeye': 'agronomeye',
        'Agworld': 'agworld',
        'File csv json excel feather parquet': 'file',
        'Gmail': 'gmail',
        'Google calendar': 'google-calendar',
        'Google drive': 'google-drive',
        'Google sheets': 'google-sheets',
        'Microsoft excel': 'microsoft-excel',
        'Microsoft onedrive': 'microsoft-onedrive',
        'Microsoft teams': 'microsoft-teams',
        'Mysql': 'mysql',
        'Outlook': 'outlook',
        'Quickbooks': 'quickbooks',
        'Xero': 'xero',
        'Bureau of Meteorology': 'bureau-of-meteorology'
      }
    }
  },
  methods: {
    navigateToConnector(sourceName) {
      const sourceId = this.sourceIds[sourceName] || sourceName.toLowerCase().replace(/ /g, '-');
      window.location.href = `/data-sources/connector/${sourceId}`;
    }
  }
}
</script>

<style scoped>
.data-sources-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
}

.page-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
}

.content-section {
  margin-bottom: 32px;
}

.source-cards {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.source-card {
  display: flex;
  align-items: center;
  padding: 20px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background-color: white;
  transition: all 0.2s ease;
}

.source-card:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.source-icon {
  margin-right: 16px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.source-info {
  flex: 1;
}

.source-name {
  font-weight: 500;
  color: #111827;
  margin-bottom: 4px;
}

.source-connect {
  font-size: 12px;
  color: #6b7280;
  text-transform: uppercase;
}

.source-status {
  display: flex;
  align-items: center;
  font-size: 12px;
}

.source-status.error {
  color: #ef4444;
}

.source-status.success {
  color: #3A895F;
}

.status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ef4444;
  margin-right: 6px;
}

.status-dot-connected {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #3A895F;
  margin-right: 6px;
}

.source-action {
  margin-left: 16px;
}

@media (min-width: 768px) {
  .source-cards {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 16px;
  }
}
</style>
